import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Login } from '@/components/HankoAuth';
import { Logo } from '@/components/Logo';
import { env } from '@/env';

const userAgent = navigator.userAgent;
const isAndroid = /android/i.test(userAgent);
const isIOS =
  /iphone|ipad|ipod/i.test(userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogin = () => {
    navigate('/', { replace: true });
  };

  return (
    <>
      <div className="md:flex">
        <div className="m-auto min-h-100vh flex items-center justify-center flex-col w-full bg-grey-100">
          <div className="shadow-md rounded-14-0 max-w-[480px] w-full p-2-0 md:p-6-0 md:pt-4-0 bg-white">
            <Logo
              type={2}
              className="flex justify-center mx-auto h-15-0 my-6-0"
              disabledLink
            />
            <p className="font-bd text-2-4 leading-1-0 my-5-0">
              {t('global.welcome_to_agrantis')}
            </p>
            <Login redirectAfterLogin={handleLogin} />
            <div className="md:hidden mt-4-0 flex flex-col items-center">
              <p className="font-md text-2-0 text-grey-800 mb-3-0">
                {t('global.download_app_hint')}
              </p>
              <div className="flex gap-2-0 justify-center">
                {!isIOS && env.VITE_GOOGLE_PLAY_STORE_APP_ID && (
                  <a
                    href={`https://play.google.com/store/apps/details?id=${env.VITE_GOOGLE_PLAY_STORE_APP_ID}`}
                  >
                    <img src="/icons/playStore.svg" alt="Google Play" />
                  </a>
                )}
                {!isAndroid && env.VITE_APPLE_APP_STORE_APP_URL && (
                  <a href={env.VITE_APPLE_APP_STORE_APP_URL}>
                    <img src="/icons/appStore.svg" alt="App Store" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
